export enum Features {
  LiveSales = "1",
  ReplyToBuy = "2",
}
